export default {"src":"/_next/static/media/xmark-solid.3470d75f.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};